<template>
  <div class="container" dir="ltr">
    <div class="title-block">
      {{ $t('PRIVACY POLICY') }}
    </div>
    <div class="flex justify-between" style="scroll-behavior: smooth">
      <div class="main-info">
        <div class="paragraph-block">
          <ol class="main-ol">
            <li ref="general" class="paragraph-title">
              {{ $t('GENERAL') }}
              <ol class="paragraph-element">
                <li v-if="isDflat">
                  {{
                    $t(
                      'VR INVEST LLC, with number 45001026 (referred to as “DreamFlat” or “we”) takes measures for the protection and the processing of your personal data on the website https://dreamflat.design (referred to as the “Website”) and the Platform (as defined in our Terms of Use).',
                    )
                  }}
                </li>
                <li v-if="!isDflat">
                  {{
                    $t(
                      'DreamFlat FZ-LLC registered in the Register of Companies of UAE, with number 45001026 (referred to as “DreamFlat” or “we”) takes measures for the protection and the processing of your personal data on the website https://dreamflat.design (referred to as the “Website”) and the Platform (as defined in our Terms of Use).',
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      'In this Privacy Policy we explain how we, as the controller, collect, if necessary share, and use personal data, and how you can exercise your rights as a data subject. This Privacy Policy should be read alongside, and in addition to, our Platform terms and conditions ',
                    )
                  }}
                  <ui-link
                    to="/terms-of-use"
                    class="link steps-link"
                    color="primary"
                  >
                    ({{ $t('Terms of Use') }})
                  </ui-link>
                  {{ $t(' and our ') }}
                  <ui-link
                    to="/cookie-policy"
                    class="link steps-link"
                    color="primary"
                  >
                    {{ $t('Cookie Policy') }}.
                  </ui-link>
                </li>
                <li>
                  {{
                    $t(
                      'We urge you (also referred to as the &quot;User&quot;) to read this Privacy Policy as well as our Terms of Use and Cookie Policy carefully before using this Platform. When you use the Platform, you are aware that you accept this Privacy Policy. If you don’t agree with this Privacy Policy and with the Terms of Use, you mustn’t use the Platform.',
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      'Providing access to the Platform, we proceed from the assumption that you:',
                    )
                  }}
                  <ol>
                    <li>
                      acting on your own behalf represent the
                      legitimate interests of a company (Business
                      User), or are acting on your own behalf and in
                      your own interest (Individual User) and have all
                      the necessary authority to register on and use
                      this Platform;
                    </li>
                    <li>
                      provide true information about yourself to the
                      extent necessary for use of the Platform
                      services;
                    </li>
                    <li>
                      are responsible for the actions you take on the
                      Platform;
                    </li>
                    <li>
                      are aware of and accept this Privacy Policy;
                    </li>
                    <li>are aware of and accept the Terms of Use.</li>
                  </ol>
                </li>
                <li>
                  We do not check the user information received from
                  you, except where such check is necessary in order
                  for us to fulfill our obligations to you or to the
                  Company.
                </li>
                <li>
                  Capitalized terms not defined here have the same
                  meaning as those defined in the Terms of Use.
                </li>
              </ol>
            </li>
            <li ref="categories-of-info" class="paragraph-title">
              {{
                $t(
                  'CATEGORIES OF INFORMANTION WE PROCESS AND PURPOSES OF SUCH PROCESSING',
                )
              }}
              <ol class="paragraph-element">
                <li>
                  In order to implement the agreement between you and
                  us (please refer to Terms of Use and License
                  Agreement), and provide you with access to the use
                  of the Platform functionality, in compliance with
                  applicable laws, we will collect, store, aggregate,
                  organise, extract, compare, use, and supplement your
                  data (hereinafter “processing”).
                </li>
                <li>
                  The information that we receive in connection with
                  and within the scope of your use of the Platform
                  (e.g. in connection with a product or service
                  request, contact form, registration, communication
                  with you personally online, or your use of
                  Platform’s services), comprise the following
                  categories:
                </li>
                <li>
                  Unless your subscription has expired or this License
                  Agreement is terminated pursuant to the terms set
                  forth in this License Agreement, you may use the
                  Software as follows:
                </li>
                <li>
                  We use this information in order to manage and
                  administer the Platform including providing our
                  services to you, to fulfill our obligations under
                  our agreement with you, as well as for the purpose
                  of sending you automatic newsletters (exclusively
                  with your consent).
                </li>
                <li>
                  Certain information that we may also automatically
                  collect from your device when you visit the
                  Platform: IP address, name of the file accessed,
                  date and time of access, amount of data transmitted,
                  notification of successful access, web browser,
                  device type and unique device identification
                  numbers.
                </li>
                <li>
                  We may also collect information about how your
                  device interacted with the Platform, such as which
                  pages were accessed and which links were clicked.
                </li>
                <li>
                  By collecting this information, we can better
                  understand who visits the Platform, where visitors
                  come from and what content on the Platform they are
                  interested in. We use this information for our
                  internal analysis and to improve the quality of the
                  Platform services and to better tailor it to the
                  interests of our visitors. Furthermore, the data can
                  be used to guarantee network and data security.
                </li>
                <li>
                  Information that is created by you while placing
                  requests to our technical support.
                </li>
                <li>
                  We use this information in order to verify your
                  identity and to fullfil your support request. We may
                  also use this data in order to investigate any
                  complaints on your behalf and to provide you with a
                  more efficient service.
                </li>
                <li>
                  Information that is received as the result of your
                  behavioral actions on the Platform including the
                  content you upload and create on the Platform.
                </li>
                <li>
                  We use this information to improve our Services and
                  Software, as well as the User experience (where your
                  consent is not required).
                </li>
                <li>
                  Information we received from other group companies
                  (as further specified herein) or third-party
                  companies that have obtained your consent or
                  otherwise have the legal right to share such
                  information with us (including publishing partners,
                  platforms, advertising platforms and partners and a
                  data aggregator). This data may include information
                  about you and your interests, as well as other
                  services you use, demographic information, and
                  information about the location of your device.
                </li>
                <li>
                  We use this information for marketing and analytical
                  purposes. We process this information in accordance
                  with this Privacy Policy, and subject to the
                  limitations set forth in the privacy policy of the
                  company that collected this information from you.
                </li>
                <li>
                  We do not use cookies or similar technologies on our
                  website to collect personal data.
                </li>
              </ol>
            </li>
            <li ref="legal-basis" class="paragraph-title">
              {{ $t('LEGAL BASIS FOR PROCESSING PERSONAL DATA') }}
              <ol class="paragraph-element">
                <li>
                  The legal basis for the collection and processing of
                  personal data depends on the specific context in
                  which we collect it:
                  <ol>
                    <li>
                      Contractual obligations (Art 6 para 1 lit b
                      GDPR): Your personal data will be processed in
                      order to manage and fulfill the contract with
                      you.
                    </li>
                    <li>
                      Legal obligations (Art 6 para 1 lit c GDPR): In
                      part, we are required by statutory or regulatory
                      obligations to process your personal data.
                    </li>
                    <li>
                      Consent (Art 6 para 1 lit a GDPR): If we have
                      received your consent, DreamFlat will process
                      your data only to the extent of the consent
                      given. You can withdraw your consent at any time
                      with effect for the future.
                    </li>
                    <li>
                      Legitimate interests (Art 6 para 1 lit f GDPR):
                      Furthermore, we may process your data on the
                      basis of legitimate interests of DreamFlat or a
                      third party. These legitimate interests include:
                      <ol>
                        <li>
                          Effective business administration and
                          development;
                        </li>
                        <li>
                          Improving our processes and practices;
                        </li>
                        <li>
                          Ensure compliance with internal guidelines
                          and policies as well as applicable laws and
                          business standards;
                        </li>
                        <li>
                          to avoid or mitigate damages for you, us and
                          third parties.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li ref="sensitive-data" class="paragraph-title">
              {{
                $t(
                  'SPECIAL CATEGORIES OF PERSONAL DATA (SENSITIVE DATA)',
                )
              }}
              <ol class="paragraph-element">
                <li>
                  Please note, that we do not collect on the Platform
                  and do not process special categories of personal
                  data revealing racial or ethnic origin, political
                  opinions, religious or philosophical beliefs, or
                  trade union membership, and the processing of
                  genetic data, biometric data, data concerning health
                  or data concerning a natural person&#39;s sex life
                  or sexual orientation.
                </li>
              </ol>
            </li>
            <li ref="payment-data" class="paragraph-title">
              {{ $t('PAYMENT DATA') }}
              <ol class="paragraph-element">
                <li>
                  Please note, that we do not process your payments
                  for use the Platform and have no access to your
                  credit card information. The payment providers
                  around the world process and store your credit card
                  details. Although we work with payment providers,
                  they are completely independent of DreamFlat. Please
                  review their respective privacy policies before
                  providing them with your data.
                </li>
                <li>
                  When you make a payment, you enter your credit card
                  details into a form provided by the payment provider
                  that will process the payment, and this information
                  goes directly to the payment provider&#39;s server.
                  Your credit card information never reaches the
                  DreamFlat servers. When you save your credit card
                  information, it is stored on the servers of the
                  relevant payment provider, and the payment provider
                  provides us with a token that you can reuse for
                  future payments. Your credit card information cannot
                  be recovered from the token.
                </li>
                <li>
                  Due to the fact that we do not process credit card
                  data or transaction information, we are not
                  authorized to handle complaints about these matters.
                  Any disputed payments are the responsibility of the
                  payment providers and banks involved in the
                  exchange.
                </li>
              </ol>
            </li>
            <li
              ref="recipients-of-personal-data"
              class="paragraph-title"
            >
              {{ $t('RECIPIENTS OF PERSONAL DATA') }}
              <ol class="paragraph-element">
                <li>
                  We may share the personal data with the following
                  recipients:
                </li>
                <li>
                  with our employees who need it to fulfill
                  contractual and legal obligations and legitimate
                  interests, group companies (as further specified
                  herein), external service providers (e.g. IT service
                  providers) and partners who provide data processing
                  services for us or who otherwise process personal
                  data for the purposes described in this Privacy
                  Policy (such as banks and financial service
                  providers, insurers, financial advisors,
                  professional consultants and external legal
                  advisors) or who are disclosed to you when we
                  collect your personal data. A list of group
                  companies, service providers and partners to whom
                  personal data is currently disclosed or who
                  currently are processing personal information on our
                  behalf, is available on request. All recipients are
                  obliged to treat your data confidentially and to
                  process it only within the framework of the
                  provision of services;
                </li>
                <li>
                  with any competent authority, such as tax,
                  supervisory or safety authorities, or public
                  authorities, a court or other third parties, when
                  disclosure is necessary (i) by law or regulation,
                  (ii) to exercise, protect or defend our statutory
                  rights, or (iii) to protect your important interests
                  or the important interests of another person; data
                  is currently disclosed or who currently are
                  processing personal information on our behalf, is
                  available on request. All recipients are obliged to
                  treat your data confidentially and to process it
                  only within the framework of the provision of
                  services;
                </li>
                <li>
                  If we merge with or are acquired by another company,
                  sell the Site, app, or business unit, or if all or a
                  substantial portion of our assets are acquired by
                  another company, your information will likely be
                  disclosed to our advisers and any other prospective
                  purchaser&#39;s advisers and will be one of the
                  assets that is transferred to the new owner.
                </li>
                <li>
                  If you publish your content on the Platform, you
                  understand and accept that your account name will be
                  available to other Users of the Platform.
                </li>
              </ol>
            </li>
            <li
              ref="obligation-to-provide-data"
              class="paragraph-title"
            >
              {{ $t('OBLIGATION TO PROVIDE DATA') }}
              <ol class="paragraph-element">
                <li>
                  We need the abovementioned data for the performance
                  of the obligations to you and/or in order to comply
                  with legal obligations we are subject to. If you
                  refuse to provide personal data which is required
                  for the performance of the agreement or which we are
                  obliged to process due to legal obligation it may
                  not be possible for us to provide the Platform’s
                  services, more specifically, the purposes listed
                  above and/or it would significantly slow down the
                  relevant purpose.
                </li>
              </ol>
            </li>
            <li ref="international" class="paragraph-title">
              {{
                $t(
                  'INTERNATIONAL DATA TRANSFER / INTRA-GROUP PROCESSING',
                )
              }}
              <ol class="paragraph-element">
                <li>
                  We may share your personal data with our parent
                  group company, DreamFlat FZ-LLC, located in Russia,
                  to help to provide, improve and support our
                  Services. We take appropriate security measures to
                  ensure that your personal data remains protected in
                  accordance with this Privacy Policy. This includes
                  the application of the European Commission&#39;s
                  standard contractual clauses for the transfer of
                  personal data. In addition, such information is
                  transmitted exclusively through secure communication
                  channels. Further details on the appropriate safety
                  precautions taken are available on request.
                </li>
              </ol>
            </li>
            <li ref="data-storage" class="paragraph-title">
              {{ $t('DATA STORAGE') }}
              <ol class="paragraph-element">
                <li>
                  Your personal data and files are stored on
                  DreamFlat&#39;s servers and those of the companies
                  we hire to provide services to us.
                </li>
              </ol>
            </li>
            <li ref="data-retention" class="paragraph-title">
              {{ $t('DATA RETENTION') }}
              <ol class="paragraph-element">
                <li>
                  We keep your personal data during the business
                  relationship as long as this is necessary for the
                  fulfilment of the purpose or as long as contractual
                  or legal obligations or legitimate interests exist
                  (e.g. to fulfil our obligations or legal storage
                  obligations, or to assert legal claims). As soon as
                  there are no legitimate purposes for the further
                  storage of personal data, these will either be
                  deleted or made anonymous. If this is not possible
                  (for example because your personal data was stored
                  in backup archives), we will store your personal
                  data securely and make it inaccessible to further
                  processing until deletion is possible.
                </li>
              </ol>
            </li>
            <li ref="automated" class="paragraph-title">
              {{ $t('AUTOMATED DECISIONS INCLUDING PROFILING') }}
              <ol class="paragraph-element">
                <li>
                  Automated decisions within the meaning of Art 22
                  GDPR mean that a decision that has legal effect on
                  you or significantly affects you in a similar way is
                  automatically made - including profiling - without
                  verification by a natural person. We do not use
                  automated decisions.
                </li>
              </ol>
            </li>
            <li ref="data-subject" class="paragraph-title">
              {{ $t('DATA SUBJECT RIGHTS') }}
              <ol class="paragraph-element">
                <li>
                  In accordance with applicable law, you have the
                  right to access, correct, request deletion of your
                  personal data, to object to the processing of your
                  personal data, and portability of your personal
                  data, to request restriction of the processing of
                  your personal data, and to file a complaint with the
                  data protection authority, when you believe your
                  data protection rights have been violated.
                </li>
                <li>
                  Many of our Services allow you to edit your personal
                  information by accessing the “my profile”, or a
                  similar feature of the service you are using.
                  Likewise, you can delete files or photos you have
                  stored in our Services and Software by logging in
                  and using the deletion functions that are available.
                </li>
                <li>
                  To exercise these rights send an email to
                  info@dreamflat.design. We will aim to respond to you
                  within one month of receipt of the request. That
                  period may be extended by two further months where
                  necessary, considering the complexity and number of
                  the requests.
                </li>
                <li>
                  If you have unresolved concerns, you have the right
                  to report them to your local privacy regulator or
                  data protection authority.
                </li>
                <li>
                  Upon your consent we may use your information to
                  provide you with information and offers related to
                  the Platform. Where we rely on your consent, you
                  will always be able to withdraw that consent,
                  although we may have other legal grounds for
                  processing your information for other purposes, such
                  as those set out above. In some cases, we are able
                  to send you direct marketing without your consent,
                  where we rely on our legitimate interests. You have
                  an absolute right to opt-out of direct marketing, or
                  profiling we carry out for direct marketing, at any
                  time by:
                  <ol>
                    <li>
                      updating your preferences in your profile;
                    </li>
                    <li>
                      updating your preferences in your specific
                      website or app accounts;
                    </li>
                    <li>
                      clicking the unsubscribe link at the bottom of
                      our marketing emails; or
                    </li>
                    <li>
                      contacting us using the details provided at the
                      end of this privacy policy.
                    </li>
                  </ol>
                </li>
                <li
                  ref="limitation-and-registration"
                  class="paragraph-title"
                >
                  {{ $t('UPDATES TO THIS PRIVACY POLICY') }}
                  <ol class="paragraph-element">
                    <li>
                      We may update this Privacy Policy to reflect
                      legal, technical or business changes. When we
                      update this Privacy Policy, we will take
                      reasonable steps to inform you of the importance
                      of the changes made. You will be prompted to
                      review any material changes to the Privacy
                      Policy we make if and to the extent required by
                      applicable data protection laws. You will find
                      the date of the &quot;last update&quot; at the
                      end of this Privacy Policy.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <div class="legal-table-contents">
        <ol>
          <li>
            <a @click="scrollToAnchorPoint('general')">{{
              $t('GENERAL')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('categories-of-info')">{{
              $t(
                'CATEGORIES OF INFORMANTION WE PROCESS AND PURPOSES OF SUCH PROCESSING',
              )
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('legal-basis')">{{
              $t('LEGAL BASIS FOR PROCESSING PERSONAL DATA')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('sensitive-data')">{{
              $t(
                'SPECIAL CATEGORIES OF PERSONAL DATA (SENSITIVE DATA)',
              )
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('payment-data')">{{
              $t('PAYMENT DATA')
            }}</a>
          </li>
          <li>
            <a
              @click="
                scrollToAnchorPoint('recipients-of-personal-data')
              "
              >{{ $t('RECIPIENTS OF PERSONAL DATA') }}</a
            >
          </li>
          <li>
            <a
              @click="
                scrollToAnchorPoint('obligation-to-provide-data')
              "
              >{{ $t('OBLIGATION TO PROVIDE DATA') }}</a
            >
          </li>
          <li>
            <a @click="scrollToAnchorPoint('international')">{{
              $t(
                'INTERNATIONAL DATA TRANSFER / INTRA-GROUP PROCESSING',
              )
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('data-storage')">{{
              $t('DATA STORAGE')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('data-retention')">{{
              $t('DATA RETENTION')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('automated')">{{
              $t('AUTOMATED DECISIONS INCLUDING PROFILING')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('data-subject')">{{
              $t('DATA SUBJECT RIGHT')
            }}</a>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {useI18n} from 'vue-i18n';
import UiLink from '~/components/Ui/UiLink.vue';
import {useHead, useRuntimeConfig} from '#imports';
export default {
  components: {UiLink},
  setup() {
    const {t} = useI18n();
    const runtimeConfig = useRuntimeConfig();
    const isDflat =
      runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');
    useHead({
      title: `${t(runtimeConfig.public.vueAppTitle)} - ${t(
        'privacyPolicy',
      )}`,
      meta: [
        {
          name: 'description',
          content: `${t('privacyMetaDesc')}`,
        },
      ],
    });
    useSeoMeta({
      ogTitle: `${t(runtimeConfig.public.vueAppTitle)} - ${t(
        'privacyPolicy',
      )}`,
      description: `${t('privacyMetaDesc')}`,
      ogDescription: `${t('privacyMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    });
    return {
      isDflat,
    };
  },
  methods: {
    scrollToAnchorPoint(refName: string) {
      const el = this.$refs[refName] as HTMLLIElement;
      el.scrollIntoView({behavior: 'smooth'});
    },
  },
};
</script>
<style lang="scss">
.title-block {
  font-size: 36px;
  font-weight: 700;
  margin: 30px 0 60px 0;
  color: #3d424a;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.main-info {
  width: 650px;
  .paragraph-block {
    color: #3d424a;
    ol {
      margin: 0 0 1.5em;
      padding: 0;
    }
    .main-ol {
      counter-reset: item;
    }
    ol > li {
      padding: 0 0 0 1.5em;
      text-indent: -1.5em;
      list-style-type: none;
    }
    ol > li:before {
      display: inline-block;
      width: 1.5em;
      padding-right: 0.5em;
      font-weight: bold;
      text-align: right;
    }
    .main-ol > li {
      counter-increment: item;
    }
    .main-ol > li:before {
      content: counter(item) '.';
    }
    .main-ol > li ol > li {
      counter-increment: item-t;
    }
    .main-ol > li ol > li:before {
      content: counter(item) '.' counter(item-t);
    }

    .main-ol > li ol > li ol > li {
      counter-increment: item-three;
      padding: 0 0 0 3.1em;
      text-indent: -1.5em;
      margin: 16px 0;
    }

    .main-ol > li ol > li ol > li:before {
      display: inline-block;
      width: 1.5em;
      padding-right: 0.5em;
      font-weight: bold;
      text-align: right;
      content: counter(item) '.' counter(item-t) '.'
        counter(item-three);
    }

    a {
      color: $primary;
      text-decoration: none;
    }
    .paragraph-title {
      font-size: 24px;
      font-weight: 700;
      .paragraph-element > * {
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0.03em;
        margin: 16px 0;
      }
    }
  }
}
.legal-table-contents {
  width: 265px;
  ol {
    color: #839aaf;
    padding: 0;
    margin: 0 0 1.1em;
    position: sticky;
    top: 50px;
    li {
      list-style-position: inside;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      padding: 0 0 0 1.1em;
      text-indent: -1.1em;
      cursor: pointer;
    }
    a {
      text-decoration: none;
      color: #839aaf;
    }
    a:active {
      color: #64686e;
    }
  }
}
.steps-link:after {
  content: '';
}
@media (max-width: 1024px) {
  .main-info {
    width: 100%;
  }
  .legal-table-contents {
    width: 100%;
  }
  .title-block {
    margin-top: 32px;
  }
}
@media (max-width: 700px) {
  .title-block {
    font-size: 24px;
    line-height: 32px;
    margin: 32px 0 24px 0;
  }
  .legal-info-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .main-info {
      width: 100%;
      .paragraph-block {
        .main-ol {
          .paragraph-title {
            font-size: 18px;
          }
          .paragraph-element {
            li {
              font-size: 15px;
              line-height: 140%;
            }
          }
        }
      }
    }
  }
  .legal-table-contents {
    display: none;
  }
}
</style>
